import React, { useEffect, useRef, useState } from 'react';
import { AgentFilledIcon } from '@domain-group/fe-co-icon';
import { isNoAgentPhoto } from '../shared/avatar';
import * as styles from './agent-profile-photo.style';

export type AgentProfilePhotoProps = {
  name: string;
  photoUrl?: string | null;
};

const AgentProfilePhoto = ({
  name,
  photoUrl,
}: AgentProfilePhotoProps): JSX.Element => {
  const imageRef = useRef<HTMLImageElement>(null);
  const [failedSrc, setFailedSrc] = useState<string | null>(null);

  // onError can fire before hydration attaches the handler.
  useEffect(() => {
    const image = imageRef.current;

    if (image && image.complete && image.naturalWidth === 0) {
      setFailedSrc(photoUrl ?? null);
    }
  }, [photoUrl]);

  const showPhoto =
    !!photoUrl && !isNoAgentPhoto(photoUrl) && photoUrl !== failedSrc;

  if (showPhoto) {
    return (
      <div css={styles.frame} data-testid="agent-profile-photo">
        <img
          ref={imageRef}
          css={styles.photo}
          src={photoUrl}
          alt={name}
          onError={() => setFailedSrc(photoUrl)}
        />
      </div>
    );
  }

  return (
    <div
      css={[styles.frame, styles.silhouetteFrame]}
      role="img"
      aria-label={name}
      data-testid="agent-profile-photo"
    >
      <AgentFilledIcon
        viewBox="0 0 18 20"
        size="custom"
        css={styles.silhouette}
        aria-hidden
        data-testid="agent-profile-photo__silhouette"
      />
    </div>
  );
};

export default AgentProfilePhoto;
